const useAvailableEntryFilters = () => {
	const availableFilters = [
		{
			key: 'arbeitsgruppe',
			name: 'arbeitsgruppe',
		},
		{
			key: 'referrer',
			name: 'herkunft_der_information',
		},
	];
	return { availableFilters };
};

export default useAvailableEntryFilters;
